<template>
  <div class="center-warp">
    <div class="inner d-flex-between">
      <div class="left-menu">
        <div :class="menuIndex == 0 ? 'on':''" @click="menuChange(0)">基本资料</div>
        <div v-if="createType != '功能矫治器' && createType != '隐形矫治器加工'" :class="menuIndex == 1 ? 'on':''" @click="menuChange(1)">图片资料</div>
        <div v-if="showMoreData" :class="menuIndex == 2 ? 'on':''" @click="menuChange(2)">补充资料</div>
      </div>
      <div ref="contRef" class="right-cont" @scroll="handScroll">
        <div ref="part1" class="add-item">
          <div class="add-data-title">基本资料</div>
          <template v-if="createType == '复诊卡'">
            <div class="d-flex-between">
              <div class="add-card-data"><span>姓名：</span><span class="black-14">{{ createItem.name }}</span></div>
              <div class="add-card-data"><span>病例年龄：</span><span class="black-14">{{ createItem.age_text }}</span>
              </div>
              <div class="add-card-data"><span>{{createItem.confirm_first_case_type_text ? '确认' : '期望'}}套餐类型：</span><span class="black-14">{{
                  createItem.confirm_first_case_type_text ? createItem.confirm_first_case_type_text : createItem.first_case_type_name
                }}</span></div>
            </div>
            <div class="d-flex-between">
              <div class="add-data-item">
                <div>复诊日期<span class="require">*</span></div>
                <el-date-picker
                    v-model="cardFuzhenOption.card_date"
                    class="add-data-item-input"
                    clear-icon="none"
                    placeholder="选择复诊日期"
                    prefix-icon="el-icon-arrow-right"
                    type="date"
                    :picker-options="pickerBornOption"
                    @change="dateChange($event,1)">
                </el-date-picker>
              </div>
            </div>
            <div class="add-data-item">
              <div>复诊情况<span class="require">*</span></div>
              <textarea v-model="cardFuzhenOption.being_treatment" class="case-main-info"
                        placeholder="填写本次复诊情况…"></textarea>
            </div>
          </template>
          <template v-if="createType == '会诊卡'">
            <div class="d-flex-between">
              <div class="add-card-data"><span>姓名：</span><span class="black-14">{{ createItem.name }}</span></div>
              <div class="add-card-data"><span>病例年龄：</span><span class="black-14">{{ createItem.age_text }}</span>
              </div>
              <div class="add-card-data"><span>{{createItem.confirm_first_case_type_text ? '确认' : '期望'}}套餐类型：</span><span class="black-14">{{
                  createItem.confirm_first_case_type_text ? createItem.confirm_first_case_type_text : createItem.first_case_type_name
                }}</span></div>
            </div>
            <div class="add-card-data"><span>首诊主诉：</span><span class="black-14">{{ createItem.case_info }}</span>
            </div>
            <div class="d-flex-between">
              <div class="add-data-item">
                <div>会诊卡时间<span class="require">*</span></div>
                <el-date-picker
                    v-model="cardHuizhenOption.card_date"
                    class="add-data-item-input"
                    clear-icon="none"
                    placeholder="选择会诊日期"
                    prefix-icon="el-icon-arrow-right"
                    :picker-options="pickerBornOption"
                    type="date"
                    @change="dateChange($event,2)">
                </el-date-picker>
              </div>
            </div>
            <div class="add-data-item">
              <div>会诊情况<span class="require">*</span></div>
              <textarea v-model="cardHuizhenOption.being_treatment" class="case-main-info"
                        placeholder="填写本次复诊情况…"></textarea>
            </div>
          </template>
          <template v-if="createType == '图像卡'">
            <div class="add-data-item">
              <div>正在进行的诊疗<span class="require">*</span></div>
              <textarea v-model="cardTuxiangOption.being_treatment" class="case-main-info"
                        placeholder="请输入正在进行的诊疗情况…"></textarea>
            </div>
          </template>
          <template v-if="createType == '功能矫治器'">
            <div class="add-data-item margin-top-16">
              <div>关联病例<span class="require">*</span></div>
              <div class="case-person on">
                <img v-if="createItem.difficulty_level" :src="createItem.difficulty_level == 'A' ? require('@/assets/img/doctor-detail/A.png') :
            createItem.difficulty_level == 'B' ? require('@/assets/img/doctor-detail/B.png') :
            createItem.difficulty_level == 'C' ? require('@/assets/img/doctor-detail/C.png') : ''
             " alt="" class="case-person-grade">
                <img v-if="createItem.finished_status == 1" alt="" class="case-person-state"
                     src="@/assets/img/doctor-detail/state-finished.png">
                <img v-if="createItem.mentor_id == ''" alt="" class="case-person-state"
                     src="@/assets/img/doctor-detail/state-new.png">
                <div class="d-flex-between" style="align-items: center">
                  <div class="case-person-name">{{ createItem.name }}
                    <div
                        v-if="(member.member_type == 0 && createItem.mentor_unreaded_count > 0) || (member.member_type == 1 && createItem.doctor_unreaded_count > 0) "
                        class="new-dot"></div>
                  </div>
                  <div class="case-person-info">{{ createItem.age }}岁</div>
                </div>
                <div class="case-person-info">{{ createItem.no }}</div>
                <div class="case-person-time-line">
                  <div v-if="createItem.sz_date" class="case-person-time">
                    <img src="@/assets/img/doctor-detail/time-shouzhen.png">
                    {{ createItem.sz_date.substring(0, 11)}}
                  </div>
                  <div v-if="createItem.new_date" class="case-person-time-split"></div>
                  <div v-if="createItem.new_date" class="case-person-time">
                    <img src="@/assets/img/doctor-detail/time-zuixin.png">
                    {{createItem.new_date.substring(0, 11)}}
                  </div>
                </div>
                <div class="case-person-cycle package-tag" :class="createItem.confirm_first_case_type != null ? '' : 'case-person-cycle-grey'">{{createItem.confirm_first_case_type_text != '' ? createItem.confirm_first_case_type_text :createItem.first_case_type_name}}</div>
              </div>
            </div>
            <div class="add-data-item">
              <div>定制类型<span class="require">*</span></div>
              <div class="take-radio">
                <div :class="cardJiaozhiOption.dz_type == 2? 'on':''" class="take-radio-item" style="width: 792px"
                     @click="radioChange(2)">
                  <div :class="cardJiaozhiOption.dz_type == 2? 'icon-yixuan':'icon-weixuan'" class="iconfont"></div>
                  <div>
                    <div class="take-radio-info1">数字模型定制</div>
                    <div class="take-radio-info2">上传stl格式文档(数字模型数据)</div>
                  </div>
                </div>
                <div :class="cardJiaozhiOption.dz_type == 1? 'on':''" class="take-radio-item" style="width: 792px"
                     @click="radioChange(1)">
                  <div :class="cardJiaozhiOption.dz_type == 1? 'icon-yixuan':'icon-weixuan'" class="iconfont"></div>
                  <div>
                    <div class="take-radio-info1">石膏模型定制</div>
                    <div class="take-radio-info2">
                      上传石膏模型、数字模型、选择石膏模型警告誉写设计单编号到纸质文档，并和石膏一起寄送。邮寄地址请联系业务员或客服获取。
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex-between">
              <div class="add-data-item">
                <div>数量<span class="require">*</span></div>
              </div>
              <div class="take-num" style="margin-top: 8px">
                <div :class="cardJiaozhiOption.number > 1 ? 'on' : ''" @click="numChange('del')">-</div>
                <input v-model="cardJiaozhiOption.number" @input="numInput">
                <div class="on" @click="numChange('add')">+</div>
              </div>
            </div>
            <div class="add-data-item">
              <div>关联设计单<span class="require">*</span></div>
              <div class="take-design-btn d-flex-between" style="width: 792px" @click="showDesignDialog = true">
                <div class="black-14">设计单</div>
                <span style="text-align: left;flex: 1;padding-left: 15px">{{ design_card_id.id ? design_card_id.type_name + ' ' +  design_card_id.card_date : "请选择设计单" }}</span>
                <i class="iconfont icon-youjiantou"></i>
              </div>
            </div>
            <div v-if="cardJiaozhiOption.dz_type == 2" class="add-data-item">
              <div>文件上传<span class="require">*</span></div>
              <div v-for="(item,index) in model_file_url" class="d-flex-between" style="align-items: center">
                <div class="grey-12" style="margin-top: 16px">{{ item.attachment }}</div>
                <div class="iconfont icon-pizhu-qingkonghuaban del-img-btn" @click="delFileGroup(index)"></div>
              </div>
              <div class="upload-img-item uploadItem3-s" style="width: 158px">
                <img alt="" class="upload-img-item-bg" src="@/assets/img/case_management/upload-img-bg2.png">
                <img alt="" class="upload-img-item-icon" src="@/assets/img/case_management/upload-file-icon.png">
                <div class="upload-img-item-name">上传文件</div>
                <input :multiple="false" type="file" @change="handleFileChange">
                <div class="input-cover"></div>
              </div>
            </div>
            <div class="add-data-item">
              <div>收货信息<span class="require">*</span></div>
            </div>
            <div class="d-flex-between">
              <div class="add-data-item">
                <div>姓名</div>
                <div class="add-data-item-input"><input v-model="cardJiaozhiOption.receiver_name" type="text"></div>
              </div>
              <div class="add-data-item">
                <div>电话</div>
                <div class="add-data-item-input"><input v-model="cardJiaozhiOption.receiver_phone" type="text"></div>
              </div>
              <div v-if="areaData.length" class="add-data-item">
                <div>地区</div>
                <el-cascader
                    v-model="receiverArea"
                    :options="areaData"
                    @change="handleAreaChange"></el-cascader>
                <!--              <div  class="add-data-item-input"><input type="text" v-model="cardJiaozhiOption.receiver_province"></div>-->
              </div>
            </div>
            <div class="add-data-item">
              <div>详细地址</div>
              <div class="add-data-item-input" style="width: 100%"><input v-model="cardJiaozhiOption.receiver_address" style="width: 100%"
                                                                          type="text">
              </div>
            </div>
          </template>
          <template v-if="createType == '隐形矫治器加工'">
            <div class="add-data-item">
              <div>文件上传<span class="require">*</span></div>
              <div v-for="(item,index) in model_file_url" class="d-flex-between" style="align-items: center">
                <div class="grey-12" style="margin-top: 16px">{{ item.attachment }}</div>
                <div class="iconfont icon-pizhu-qingkonghuaban del-img-btn" @click="delFileGroup(index)"></div>
              </div>
              <div class="upload-img-item uploadItem3-s" style="width: 158px">
                <img alt="" class="upload-img-item-bg" src="@/assets/img/case_management/upload-img-bg2.png">
                <img alt="" class="upload-img-item-icon" src="@/assets/img/case_management/upload-file-icon.png">
                <div class="upload-img-item-name">上传文件</div>
                <input :multiple="false" type="file" @change="handleFileChange">
                <div class="input-cover"></div>
              </div>
            </div>
            <div class="add-data-item margin-top-16">
              <div>关联病例<span class="require">*</span></div>
              <div class="case-person on">
                <img v-if="createItem.difficulty_level" :src="createItem.difficulty_level == 'A' ? require('@/assets/img/doctor-detail/A.png') :
            createItem.difficulty_level == 'B' ? require('@/assets/img/doctor-detail/B.png') :
            createItem.difficulty_level == 'C' ? require('@/assets/img/doctor-detail/C.png') : ''
             " alt="" class="case-person-grade">
                <img v-if="createItem.finished_status == 1" alt="" class="case-person-state"
                     src="@/assets/img/doctor-detail/state-finished.png">
                <img v-if="createItem.mentor_id == ''" alt="" class="case-person-state"
                     src="@/assets/img/doctor-detail/state-new.png">
                <div class="d-flex-between" style="align-items: center">
                  <div class="case-person-name">{{ createItem.name }}
                    <div
                        v-if="(member.member_type == 0 && createItem.mentor_unreaded_count > 0) || (member.member_type == 1 && createItem.doctor_unreaded_count > 0) "
                        class="new-dot"></div>
                  </div>
                  <div class="case-person-info">{{ createItem.age }}岁</div>
                </div>
                <div class="case-person-info">{{ createItem.no }}</div>
                <div class="case-person-time-line">
                  <div v-if="createItem.sz_date" class="case-person-time">
                    <img src="@/assets/img/doctor-detail/time-shouzhen.png">
                    {{createItem.sz_date.substring(0, 11)}}
                  </div>
                  <div v-if="createItem.new_date" class="case-person-time-split"></div>
                  <div v-if="createItem.new_date" class="case-person-time">
                    <img src="@/assets/img/doctor-detail/time-zuixin.png">
                    {{createItem.new_date.substring(0, 11)}}
                  </div>
                </div>
                <div class="case-person-cycle package-tag" :class="createItem.confirm_first_case_type != null ? '' : 'case-person-cycle-grey'">{{createItem.confirm_first_case_type_text != '' ? createItem.confirm_first_case_type_text :createItem.first_case_type_name}}</div>
              </div>
            </div>
            <div class="add-data-item">
              <div>关联复诊卡<span class="require">*</span></div>
              <div class="take-design-btn d-flex-between" style="width: 792px" @click="openDesignDia">
                <div class="black-14">复诊卡</div>
                <span style="text-align: left;flex: 1;padding-left: 15px">{{ design_card_id.id ? design_card_id.type_name + ' ' +  design_card_id.card_date : "请选择复诊卡" }}</span>
                <i class="iconfont icon-youjiantou"></i>
              </div>
            </div>
          </template>
        </div>
        <div v-if="createType != '功能矫治器' && createType != '隐形矫治器加工'" ref="part2" class="add-item">
          <div class="add-data-title">图片资料 <span>请上传图片资料</span></div>
          <div v-if="createType == '复诊卡' || createType == '会诊卡'" class="upload-img-warp">
            <div class="upload-img-line">
              <div class="upload-img-item uploadItem3-l">
                <template v-if="addCardImgOption.cemian_pic == ''">
                  <el-upload drag accept="image/*" :show-file-list="false" :http-request="uploadImgPre"
                             :action="'cemian_pic'">
                    <img class="upload-img-item-bg" src="@/assets/img/case_management/upload-img-bg1.png" alt="">
                    <img class="upload-img-item-icon" src="@/assets/img/case_management/upload-img-icon.png" alt="">
                  </el-upload>
                  <div class="upload-img-item-name" >侧面照</div>
                </template>
                <template v-else>
                  <img @click="editCaseImg('cemian_pic')" class="upload-img-item-val" :src="addCardImgOption.cemian_pic" alt="">
                  <img @click="delCaseImg('cemian_pic')" class="upload-img-item-del" src="@/assets/img/case_management/del2.png" alt="">
                </template>
              </div>
              <div class="upload-img-item uploadItem3-l">
                <template v-if="addCardImgOption.zhengmian_pic == ''">
                  <el-upload drag accept="image/*" :show-file-list="false" :http-request="uploadImgPre"
                             :action="'zhengmian_pic'">
                    <img class="upload-img-item-bg" src="@/assets/img/case_management/upload-img-bg1.png" alt="">
                    <img class="upload-img-item-icon" src="@/assets/img/case_management/upload-img-icon.png" alt="">
                  </el-upload>
                  <div class="upload-img-item-name" >正面照</div>
                </template>
                <template v-else>
                  <img @click="editCaseImg('zhengmian_pic')" class="upload-img-item-val" :src="addCardImgOption.zhengmian_pic" alt="">
                  <img @click="delCaseImg('zhengmian_pic')" class="upload-img-item-del" src="@/assets/img/case_management/del2.png" alt="">
                </template>
              </div>
              <div class="upload-img-item uploadItem3-l">
                <template v-if="addCardImgOption.zhengmian_weixiao_pic == ''">
                  <el-upload drag accept="image/*" :show-file-list="false" :http-request="uploadImgPre"
                             :action="'zhengmian_weixiao_pic'">
                    <img class="upload-img-item-bg" src="@/assets/img/case_management/upload-img-bg1.png" alt="">
                    <img class="upload-img-item-icon" src="@/assets/img/case_management/upload-img-icon.png" alt="">
                  </el-upload>
                  <div class="upload-img-item-name" >正面微笑照</div>
                </template>
                <template v-else>
                  <img @click="editCaseImg('zhengmian_weixiao_pic')" class="upload-img-item-val" :src="addCardImgOption.zhengmian_weixiao_pic" alt="">
                  <img @click="delCaseImg('zhengmian_weixiao_pic')" class="upload-img-item-del" src="@/assets/img/case_management/del2.png" alt="">
                </template>
              </div>
            </div>
            <div class="upload-img-line">
              <div class="upload-img-item uploadItem3-s">
                <template v-if="addCardImgOption.youce_yaohe_pic == ''">
                  <el-upload drag accept="image/*" :show-file-list="false" :http-request="uploadImgPre"
                             :action="'youce_yaohe_pic'">
                    <img class="upload-img-item-bg" src="@/assets/img/case_management/upload-img-bg2.png" alt="">
                    <img class="upload-img-item-icon" src="@/assets/img/case_management/upload-img-icon.png" alt="">
                  </el-upload>
                  <div class="upload-img-item-name" >右侧位咬合照</div>
                </template>
                <template v-else>
                  <img @click="editCaseImg('youce_yaohe_pic')" class="upload-img-item-val" :src="addCardImgOption.youce_yaohe_pic" alt="">
                  <img @click="delCaseImg('youce_yaohe_pic')" class="upload-img-item-del" src="@/assets/img/case_management/del2.png" alt="">
                </template>
              </div>
              <div class="upload-img-item uploadItem3-s">
                <template v-if="addCardImgOption.zhengwei_yaohe_pic == ''">
                  <el-upload drag accept="image/*" :show-file-list="false" :http-request="uploadImgPre"
                             :action="'zhengwei_yaohe_pic'">
                    <img class="upload-img-item-bg" src="@/assets/img/case_management/upload-img-bg2.png" alt="">
                    <img class="upload-img-item-icon" src="@/assets/img/case_management/upload-img-icon.png" alt="">
                  </el-upload>
                  <div class="upload-img-item-name" >正位咬合照</div>
                </template>
                <template v-else>
                  <img @click="editCaseImg('zhengwei_yaohe_pic')" class="upload-img-item-val" :src="addCardImgOption.zhengwei_yaohe_pic" alt="">
                  <img @click="delCaseImg('zhengwei_yaohe_pic')" class="upload-img-item-del" src="@/assets/img/case_management/del2.png" alt="">
                </template>
              </div>
              <div class="upload-img-item uploadItem3-s">
                <template v-if="addCardImgOption.zuoce_yaohe_pic == ''">
                  <el-upload drag accept="image/*" :show-file-list="false" :http-request="uploadImgPre"
                             :action="'zuoce_yaohe_pic'">
                    <img class="upload-img-item-bg" src="@/assets/img/case_management/upload-img-bg2.png" alt="">
                    <img class="upload-img-item-icon" src="@/assets/img/case_management/upload-img-icon.png" alt="">
                  </el-upload>
                  <div class="upload-img-item-name" >左侧咬合照</div>
                </template>
                <template v-else>
                  <img @click="editCaseImg('zuoce_yaohe_pic')" class="upload-img-item-val" :src="addCardImgOption.zuoce_yaohe_pic" alt="">
                  <img @click="delCaseImg('zuoce_yaohe_pic')" class="upload-img-item-del" src="@/assets/img/case_management/del2.png" alt="">
                </template>
              </div>
            </div>
            <div class="upload-img-line">
              <div class="upload-img-item uploadItem1">
                <template v-if="addCardImgOption.quanjing_pic == ''">
                  <el-upload drag accept="image/*" :show-file-list="false" :http-request="uploadImgPre"
                             :action="'quanjing_pic'">
                    <img class="upload-img-item-bg" src="@/assets/img/case_management/upload-img-bg3.png" alt="">
                    <img class="upload-img-item-icon" src="@/assets/img/case_management/upload-img-icon.png" alt="">
                  </el-upload>
                  <div class="upload-img-item-name" >全景照</div>
                </template>
                <template v-else>
                  <img @click="editCaseImg('quanjing_pic')" class="upload-img-item-val" :src="addCardImgOption.quanjing_pic" alt="">
                  <img @click="delCaseImg('quanjing_pic')" class="upload-img-item-del" src="@/assets/img/case_management/del2.png" alt="">
                </template>
              </div>
            </div>
            <div class="upload-img-line">
              <div class="upload-img-item uploadItem2">
                <template v-if="addCardImgOption.ceweimian_x_pic == ''">
                  <el-upload drag accept="image/*" :show-file-list="false" :http-request="uploadImgPre"
                             :action="'ceweimian_x_pic'">
                    <img class="upload-img-item-bg" src="@/assets/img/case_management/upload-img-bg4.png" alt="">
                    <img class="upload-img-item-icon" src="@/assets/img/case_management/upload-img-icon.png" alt="">
                  </el-upload>
                  <div class="upload-img-item-name" >侧位片(X光)</div>
                </template>
                <template v-else>
                  <img @click="editCaseImg('ceweimian_x_pic')" class="upload-img-item-val" :src="addCardImgOption.ceweimian_x_pic" alt="">
                  <img @click="delCaseImg('ceweimian_x_pic')" class="upload-img-item-del" src="@/assets/img/case_management/del2.png" alt="">
                </template>
              </div>
              <div>
                <div class="upload-img-line">
                  <div class="upload-img-item uploadItem3-s">
                    <template v-if="addCardImgOption.shanglingyalie_pic == ''">
                      <el-upload drag accept="image/*" :show-file-list="false" :http-request="uploadImgPre"
                                 :action="'shanglingyalie_pic'">
                        <img class="upload-img-item-bg" src="@/assets/img/case_management/upload-img-bg2.png" alt="">
                        <img class="upload-img-item-icon" src="@/assets/img/case_management/upload-img-icon.png" alt="">
                      </el-upload>
                      <div class="upload-img-item-name" >上颌牙列照</div>
                    </template>
                    <template v-else>
                      <img @click="editCaseImg('shanglingyalie_pic')" class="upload-img-item-val" :src="addCardImgOption.shanglingyalie_pic" alt="">
                      <img @click="delCaseImg('shanglingyalie_pic')" class="upload-img-item-del" src="@/assets/img/case_management/del2.png" alt="">
                    </template>
                  </div>
                </div>
                <div class="upload-img-line" style="margin-bottom: 0">
                  <div class="upload-img-item uploadItem3-s">
                    <template v-if="addCardImgOption.xialingyalie_pic == ''">
                      <el-upload drag accept="image/*" :show-file-list="false" :http-request="uploadImgPre"
                                 :action="'xialingyalie_pic'">
                        <img class="upload-img-item-bg" src="@/assets/img/case_management/upload-img-bg2.png" alt="">
                        <img class="upload-img-item-icon" src="@/assets/img/case_management/upload-img-icon.png" alt="">
                      </el-upload>
                      <div class="upload-img-item-name" >下颌牙列照</div>
                    </template>
                    <template v-else>
                      <img @click="editCaseImg('xialingyalie_pic')" class="upload-img-item-val" :src="addCardImgOption.xialingyalie_pic" alt="">
                      <img @click="delCaseImg('xialingyalie_pic')" class="upload-img-item-del" src="@/assets/img/case_management/del2.png" alt="">
                    </template>
                  </div>
                </div>
              </div>
            </div>
            <div class="upload-img-line">
              <div class="upload-img-item uploadItem3-m">
                <template v-if="addCardImgOption.fuhe_fugai_pic == ''">
                  <el-upload drag accept="image/*" :show-file-list="false" :http-request="uploadImgPre"
                             :action="'fuhe_fugai_pic'">
                    <img class="upload-img-item-bg" src="@/assets/img/case_management/upload-img-bg2.png" alt="">
                    <img class="upload-img-item-icon" src="@/assets/img/case_management/upload-img-icon.png" alt="">
                  </el-upload>
                  <div class="upload-img-item-name" >覆合覆盖照</div>
                </template>
                <template v-else>
                  <img @click="editCaseImg('fuhe_fugai_pic')" class="upload-img-item-val" :src="addCardImgOption.fuhe_fugai_pic" alt="">
                  <img @click="delCaseImg('fuhe_fugai_pic')" class="upload-img-item-del" src="@/assets/img/case_management/del2.png" alt="">
                </template>
              </div>
              <div class="upload-img-item uploadItem3-m">
                <template v-if="addCardImgOption.zhengmian_kaikou_zhao == ''">
                  <el-upload drag accept="image/*" :show-file-list="false" :http-request="uploadImgPre"
                             :action="'zhengmian_kaikou_zhao'">
                    <img class="upload-img-item-bg" src="@/assets/img/case_management/upload-img-bg2.png" alt="">
                    <img class="upload-img-item-icon" src="@/assets/img/case_management/upload-img-icon.png" alt="">
                  </el-upload>
                  <div class="upload-img-item-name" >正面开口照</span></div>
                </template>
                <template v-else>
                  <img @click="editCaseImg('zhengmian_kaikou_zhao')" class="upload-img-item-val" :src="addCardImgOption.zhengmian_kaikou_zhao" alt="">
                  <img @click="delCaseImg('zhengmian_kaikou_zhao')" class="upload-img-item-del" src="@/assets/img/case_management/del2.png" alt="">
                </template>
              </div>
              <div class="upload-img-item uploadItem3-m">
                <template v-if="addCardImgOption.zhengmian_yangshi_pic == ''">
                  <el-upload drag accept="image/*" :show-file-list="false" :http-request="uploadImgPre"
                             :action="'zhengmian_yangshi_pic'">
                    <img class="upload-img-item-bg" src="@/assets/img/case_management/upload-img-bg2.png" alt="">
                    <img class="upload-img-item-icon" src="@/assets/img/case_management/upload-img-icon.png" alt="">
                  </el-upload>
                  <div class="upload-img-item-name" >正面仰视照</div>
                  <div class="upload-img-item-tips">注: 反合病例替换为正面切对切咬合照</div>
                </template>
                <template v-else>
                  <img @click="editCaseImg('zhengmian_yangshi_pic')" class="upload-img-item-val" :src="addCardImgOption.zhengmian_yangshi_pic" alt="">
                  <img @click="delCaseImg('zhengmian_yangshi_pic')" class="upload-img-item-del" src="@/assets/img/case_management/del2.png" alt="">
                </template>
              </div>
            </div>
          </div>
          <div v-if="createType == '图像卡'" class="upload-img-warp">
            <template v-for="(item,index) in cardTuxiangOption.image_card_list">
              <div class="d-flex-between" style="align-items: center">
                <div class="add-card-data"><span>图片{{ index + 1 }}</span></div>
                <div v-if="index != 0" class="iconfont icon-pizhu-qingkonghuaban del-img-btn"
                     @click="delImgGroup(index)"></div>
              </div>
              <div class="d-flex-warp upload-tuxiang-line">
                <div v-for="(subItem,subIndex) in item.img" class="upload-img-item uploadItem3-s">
                    <img :src="subItem" alt="" class="upload-img-item-val" @click="editCardImg(index,subIndex)">
                    <img alt="" class="upload-img-item-del"
                         src="@/assets/img/case_management/del2.png" @click="delCardImg(index,subIndex)">
                </div>
                <div class="upload-img-item uploadItem3-s">
<!--                  <img alt="" class="upload-img-item-bg" src="@/assets/img/case_management/upload-img-bg2.png">-->
<!--                  <img alt="" class="upload-img-item-icon" src="@/assets/img/case_management/upload-img-icon.png">-->
<!--                  <div class="upload-img-item-name">上传照片</div>-->
<!--                  <input :multiple="true" accept="image/*" type="file"-->
<!--                         @change="handleCardImgChange($event ,index)">-->
<!--                  <div class="input-cover"></div>-->
                  <el-upload drag accept="image/*" :show-file-list="false" :http-request="uploadImgCardPre" :multiple="true"
                             :action="''" :data="{i:index}">
                    <img class="upload-img-item-bg" src="@/assets/img/case_management/upload-img-bg2.png" alt="">
                    <img class="upload-img-item-icon" src="@/assets/img/case_management/upload-img-icon.png" alt="">
                  </el-upload>
                </div>
              </div>
              <textarea v-model="item.text" class="case-main-info" placeholder="请输入图片描述内容"></textarea>
            </template>
            <div class="add-tupian-btn black-14" @click="addImgGroup"><i class="iconfont icon-xinzeng"></i>再加一组图片
            </div>
          </div>
        </div>
        <div v-if="showMoreData" ref="part3" class="add-item">
          <div class="add-data-title">补充视频资料</div>
          <div class="case-upload-line">
            <div v-for="i in 2" class="upload-video-item">
              <video controls src="../../assets/img/case_management/test.mp4" ></video>
              <div>MP4</div>
              <img alt="" class="upload-img-item-del" src="../../assets/img/case_management/del2.png">
            </div>
            <div class="upload-video">
              <img alt="" class="upload-video-bg" src="../../assets/img/case_management/upload-video-bg.png">
              <img alt="" class="upload-video-icon" src="../../assets/img/case_management/upload-video-icon.png">
              <div class="black-14">上传视频</div>
            </div>
          </div>
        </div>
        <div class="annotate-btn">
          <div @click="goBack">取消</div>
          <div @click="saveAddCase">保存</div>
        </div>
      </div>
      <el-dialog
          :close-on-click-modal="false"
          :visible.sync="showImgEditor"
          custom-class="take-dialog"
          title="图片编辑"
          width="1080px">
        <div class="img-editor-warp">
          <div style="width: 1040px;height: 760px;">
            <EditImg ref="editImg" :key="createType == '图像卡' ? editImgUrl : addCardImgOption[editImgName]" :bgUrl="createType == '图像卡' ? editImgUrl : addCardImgOption[editImgName]" />
          </div>
          <div class="d-flex" style="justify-content: flex-end">
            <div class="img-editor-right-btn">
              <div @click="showImgEditor = false">取消</div>
              <div @click="editImgOK">确定</div>
            </div>
          </div>
        </div>
      </el-dialog>
      <el-dialog
          :visible.sync="showDesignDialog"
          custom-class="take-dialog"
          :title="createType == '隐形矫治器加工' ? '选择复诊卡' :'选择设计单' "
          width="340px">
        <el-dialog
            :visible.sync="showDesignModelDialog"
            append-to-body
            custom-class="take-dialog"
            width="340px">
          <div slot="title" class="dialog-title">选择模板 <span>新建的设计单模板</span></div>
          <div class="d-flex-between">
            <div v-for="item in designModel" class="design-item" @click="designType = item">
              <div :class="designType.id == item.id? 'design-item-on':''" class="design-item-img">
                <img :src="item.item_comment" alt="">
              </div>
              <div class="design-item-name">
                <div :class="designType.id == item.id? 'icon-yixuan':'icon-weixuan'" class="iconfont"></div>
                {{ item.name }}
              </div>
            </div>
          </div>
          <div class="take-dialog-bottom">
            <div class="take-dialog-close" @click="showDesignModelDialog = false">取消</div>
            <div class="take-dialog-open" @click="addDesignCard">确定</div>
          </div>
        </el-dialog>
        <div v-if="createType == '功能矫治器'" class="add-design-btn black-14" @click="showDesignModelDialog = true">+ 新建设计单</div>
        <div v-if="createType == '隐形矫治器加工'" class="add-design-btn black-14" @click="createFuzhen">+ 新建复诊卡</div>
        <div class="design-list-warp">
          <div v-for="item in designCardList" :class="item.id == design_card_id.id ? 'design-list-on' : ''"
               class="design-list d-flex-between" @click="confirmDesignId(item)">
            <div class="black-14">{{ item.type_name }} {{ item.card_date }}</div>
            <div class="iconfont icon-yulan" @click.stop="showDesignCard(item.id)"></div>
          </div>
        </div>
<!--        <div class="take-dialog-bottom">-->
<!--          <div class="take-dialog-close" @click="showDesignDialog = false">取消</div>-->
<!--          <div class="take-dialog-open" @click="confirmDesignId">确定</div>-->
<!--        </div>-->
      </el-dialog>
    </div>
  </div>
</template>

<script>
import EditImg from '@/components/EditImg'
import {CreateCaseCard, GetArea, GetCardList, GetCaseInfo, GetListByTypeCode, GetLpyxjzWebUrl} from "@/http/api";
import ossUpload from "@/http/ossUpload";

export default {
  name: "add_case",
  components: {EditImg},
  data() {
    return {
      menuIndex: 0,
      menuOffsetTop: [],
      packageType: {},
      showImgEditor: false,
      createType: '',
      createItem: {},
      cutImgUrl: require('../../assets/img/case_management/test-upload-img.png'),
      cardFuzhenOption: {
        being_treatment: '',
        card_date: ''
      },
      cardHuizhenOption: {
        being_treatment: '',
        card_date: ''
      },
      cardTuxiangOption: {
        being_treatment: '',
        image_card_list: [{
          text: '',
          img: []
        }]
      },
      cardJiaozhiOption: {
        number: 1,
        dz_type: 2,
        design_card_id: '',
        model_file_url: [],
        receiver_name: '',
        receiver_phone: '',
        receiver_province: '',
        receiver_city: '',
        receiver_district: '',
        receiver_address: '',
      },
      cardYinxinOption: {
        fuzhen_card_id: '',
        model_file_url:[]
      },
      design_card_id: {},
      model_file_url: [],
      addCardImgOption: {
        cemian_pic: '',//侧面照
        ceweimian_x_pic: '',//侧位面x照
        first_case_type: '',//期望套餐类型，4：快乐+,5：散件,6：全周期（含耗材）7：双期第一期（含耗材）8：双期第二期（含耗材）注意：如果不传这个值，默认就为散件
        fuhe_fugai_pic: '',//覆合覆盖照
        other_media_json: [],//其他图文或者视频资料
        quanjing_pic: '',//全景片
        shanglingyalie_pic: '', //上领牙列照
        xialingyalie_pic: '', //下领牙列照
        youce_yaohe_pic: '', //右侧位咬合照
        zhengmian_kaikou_zhao: '',//正面开口照
        zhengmian_pic: '', //正面照
        zhengmian_weixiao_pic: '', //正面微笑照
        zhengmian_yangshi_pic: '', //正面仰视照
        zhengwei_yaohe_pic: '', //正位咬合照
        zuoce_yaohe_pic: '',  //左侧位咬合照
      },
      editImgName: '',
      editImgId: [],
      editImgUrl: '',
      showMoreData: false,
      member: JSON.parse(localStorage.getItem('member')),
      showDesignDialog: false,
      designCardList: [],
      designModel: [],
      showDesignModelDialog: false,
      designType: {},
      areaData: {},
      receiverArea: [],
      pickerBornOption:{
        disabledDate(time){
          return time.getTime() > new Date().getTime()
        }
      }
    }
  },
  mounted() {
    this.createType = this.$route.query.name
    this.$store.commit('breadChange', {name: `新建${this.createType}`, isBack: true,url:'/case_management'})
    if (this.createType == '复诊卡') this.cardFuzhenOption.card_date = new Date()
    if (this.createType == '会诊卡') this.cardHuizhenOption.card_date = new Date()
    this.$nextTick(() => {
      this.menuOffsetTop[0] = this.$refs.part1.offsetTop
      if (this.createType != '功能矫治器' && this.createType != '隐形矫治器加工') this.menuOffsetTop[1] = this.$refs.part2.offsetTop
      else this.menuOffsetTop[1] = 9999
      if (this.showMoreData) this.menuOffsetTop[2] = this.$refs.part3.offsetTop
      else this.menuOffsetTop[2] = 9999
    })
    GetCaseInfo({id: this.$route.query.id}).then(res => {
      this.createItem = res.data
      //类型为功能矫治器时获取病例设计单列表
      if (this.createType == '功能矫治器') {
        GetCardList({type_id: 5, patient_id: res.data.id}).then(res2 => {
          this.designCardList = res2.data.data
          //检查是否返回了设计单id，有就直接选中
          let designId = this.$route.query.designId;
          if (Array.isArray(designId)) designId = designId[designId.length - 1];
          if(designId){
            for (let i = 0; i < res2.data.data.length; i++) {
              if(res2.data.data[i].id == designId) {
                this.design_card_id = res2.data.data[i]
                this.cardJiaozhiOption.design_card_id = res2.data.data[i].id
              }
            }
          }
        })
        let obj = {
          receiver_name : res.data.doctor.real_name,
          receiver_phone : res.data.doctor.telephone,
          receiver_province : res.data.doctor.province,
          receiver_city : res.data.doctor.city,
          receiver_district : res.data.doctor.district,
          receiver_address : res.data.doctor.detail_address
        }
        this.cardJiaozhiOption = {
          ...this.cardJiaozhiOption,
          ...obj,
        }
        this.receiverArea = [res.data.doctor.province,res.data.doctor.city,res.data.doctor.district]
      }
      if (this.createType == '隐形矫治器加工'){
        //如果是隐形矫治器加工，则查询复诊卡
        GetCardList({type_id: 2, patient_id: res.data.id}).then(res2 => {
          this.designCardList = res2.data.data
        })
      }
    })
    if (this.createType == '功能矫治器') {
      GetListByTypeCode({type_code: ['shejidanmoban']}).then(res => {
        this.designModel = res.data.shejidanmoban
      })
      GetArea({level: 3}).then(res => {
        this.areaData = res.data
      })
    }


  },
  methods: {
    handScroll(e) {
      if (e.target.scrollTop < this.menuOffsetTop[1] - 10) {
        this.menuIndex = 0
      } else if (e.target.scrollTop >= this.menuOffsetTop[1] - 20 && e.target.scrollTop < this.menuOffsetTop[2] - 20) {
        this.menuIndex = 1
      } else this.menuIndex = 2

    },
    menuChange(i) {
      this.menuIndex = i
      this.$refs.contRef.scrollTo({
        top: this.menuOffsetTop[i],
        behavior: 'smooth'
      })
    },
    bornDateChange(val) {
      this.addCardImgOption.birthday = val
    },
    dateChange(val, i) {
      if (i == 1) this.cardFuzhenOption.card_date = val
      if (i == 2) this.cardHuizhenOption.card_date = val
    },
    handelPackageChange(val) {
      this.packageType = val
    },
    realTime(data) {
      // console.log(data)
    },
    radioChange(val) {
      this.cardJiaozhiOption.dz_type = val
    },
    handleAreaChange(val) {
      this.receiverArea = val
      this.cardJiaozhiOption.receiver_province = val[0]
      this.cardJiaozhiOption.receiver_city = val[1]
      this.cardJiaozhiOption.receiver_district = val[2]
    },
    numChange(type) {
      if (type == 'del' && this.cardJiaozhiOption.number > 1) this.cardJiaozhiOption.number = Number(this.cardJiaozhiOption.number) - 1
      if (type == 'add') this.cardJiaozhiOption.number = Number(this.cardJiaozhiOption.number) + 1
    },
    numInput() {
      if (isNaN(this.cardJiaozhiOption.number)) {
        this.cardJiaozhiOption.number = 1
      }
    },
    imgRotate(type) {
      if (type == 'left') {
        this.$refs.cropper.rotateLeft()
      } else {
        this.$refs.cropper.rotateRight()
      }
    },
    editImgOK() {
      let blobUrl = this.$refs.editImg.saveImg()
      this.uploadImg(blobUrl)
      this.showImgEditor = false
    },
    uploadImg(file) {
      ossUpload.bucketUpload(file, (res) => {
        console.log(res.url)
        if (this.createType == '图像卡') this.$set(this.cardTuxiangOption.image_card_list[this.editImgId[0]].img, this.editImgId[1], res.url)
        else this.$set(this.addCardImgOption,this.editImgName,res.url)

        console.log(this.addCardImgOption)
      }, (err) => {
        this.$message({
          type: "error",
          message: '上传失败'
        })
      }, 'duole-images', '/upload/image/pc/create_card/')
    },
    handleFileChange(e) {
      ossUpload.bucketUpload(e.target.files[0], (res) => {
        this.cardJiaozhiOption.model_file_url.push(res.url)
        this.cardYinxinOption.model_file_url.push(res.url)
        this.model_file_url.push(res)
        console.log(this.model_file_url)
      }, (err) => {
        console.log('err')
        console.log(err)
        this.$message({
          type: "error",
          message: '上传失败'
        })
      }, 'duole-images', '/upload/image/file/create_card/')
    },
    uploadImgPre(e){
      this.handleImgChange(e.file,e.action)
    },
    handleImgChange(file, name) {
      ossUpload.bucketUpload(file, (res) => {
        this.addCardImgOption[name] = res.url
        console.log(this.addCardImgOption)
      }, (err) => {
        this.$message({
          type: "error",
          message: '上传失败'
        })
      }, 'duole-images', '/upload/image/pc/create_card/')
    },
    uploadImgCardPre(e){
      this.handleCardImgChange(e.file,e.data.i)
    },
    handleCardImgChange(file, i1) {
      ossUpload.bucketUpload(file, (res) => {
        this.cardTuxiangOption.image_card_list[i1].img.push(res.url)
      }, (err) => {
        this.$message({
          type: "error",
          message: '上传失败'
        })
      }, 'duole-images', '/upload/image/pc/create_card/')
    },
    // handleCardImgChange(e, i1) {
    //   for (let i = 0; i < e.target.files.length; i++) {
    //     ossUpload.bucketUpload(e.target.files[i], (res) => {
    //       this.cardTuxiangOption.image_card_list[i1].img.push(res.url)
    //     }, (err) => {
    //       this.$message({
    //         type: "error",
    //         message: '上传失败'
    //       })
    //     }, 'duole-images', '/upload/image/pc/create_card/')
    //   }
    // },
    delCaseImg(name) {
      this.addCardImgOption[name] = ''
    },
    delCardImg(i1, i2) {
      this.cardTuxiangOption.image_card_list[i1].img.splice(i2, 1)
    },
    delImgGroup(i) {
      this.cardTuxiangOption.image_card_list.splice(i, 1)
    },
    delFileGroup(i) {
      this.cardJiaozhiOption.model_file_url.splice(i, 1)
      this.model_file_url.splice(i, 1)
    },
    editCaseImg(name) {
      this.editImgName = name
      this.showImgEditor = true
    },
    editCardImg(i1, i2) {
      this.editImgId = [i1, i2]
      this.editImgUrl = this.cardTuxiangOption.image_card_list[i1].img[i2]
      this.showImgEditor = true
    },
    addImgGroup() {
      this.cardTuxiangOption.image_card_list.push({
        text: '',
        img: []
      })
    },
    addDesignCard() {
      console.log(111);
      this.$router.push({
        name: '新增设计单',
        query: {
          patient_id: this.createItem.id,
          shejidan_id: this.designType.id,
          from: window.location.href,
          // shejidan_type: this.designType.item_value,
          // shejidan_img: this.designType.item_comment,
          // patient_id: this.createItem.id,
        }
      })
    },
    showDesignCard(id) {
      let openUrl = this.$router.resolve({
        name:'病历管理',
        query:{
          id:this.createItem.id,
          card_id:id
        }
      })
      window.open(openUrl.href,'_blank')
    },
    createFuzhen(){
      // 创建复诊卡
      this.showDesignDialog = false
      let newUrl = this.$router.resolve({
        name:'新增资料卡',
        query:{
          name:'复诊卡',
          id:this.createItem.id
        }
      })
      window.open(newUrl.href, '_blank')
    },
    goBack(){
      this.$router.push('/case_management?id=' + this.createItem.id)
    },
    confirmDesignId(val){
      this.design_card_id = val
      this.showDesignDialog = false
      this.cardJiaozhiOption.design_card_id = val.id
      this.cardYinxinOption.fuzhen_card_id = val.id
    },
    openDesignDia(){
      this.showDesignDialog = true
      GetCardList({type_id: 2, patient_id: this.createItem.id}).then(res2 => {
        this.designCardList = res2.data.data
      })
    },
    saveAddCase() {
      if (!this.$store.state.workState) return false
      let wrongTxt = ''
      let obj = {}
      if (this.createType == '复诊卡') {
        this.cardFuzhenOption.card_date = new Date(this.cardFuzhenOption.card_date).toLocaleDateString().replaceAll('/', '.')
        if (this.cardFuzhenOption.card_date == '') wrongTxt = '复诊日期不能为空'
        else if (this.cardFuzhenOption.being_treatment.trim() == '') wrongTxt = '复诊情况不能为空'
        obj = {
          ...this.cardFuzhenOption,
          ...this.addCardImgOption,
          type_id: 2,
          patient_id: this.createItem.id
        }
      } else if (this.createType == '会诊卡') {
        this.cardHuizhenOption.card_date = new Date(this.cardHuizhenOption.card_date).toLocaleDateString().replaceAll('/', '.')
        if (this.cardHuizhenOption.card_date == '') wrongTxt = '会诊卡时间不能为空'
        else if (this.cardHuizhenOption.being_treatment.trim() == '') wrongTxt = '会诊卡情况不能为空'
        obj = {
          ...this.cardHuizhenOption,
          ...this.addCardImgOption,
          type_id: 3,
          patient_id: this.createItem.id
        }
      } else if (this.createType == '图像卡') {
        let textIndex =  this.cardTuxiangOption.image_card_list.find((item, index) => {
          return item.text.trim() == ''
        })
        let imgIndex = this.cardTuxiangOption.image_card_list.find((item, index) => {
          return item.img.length == 0
        })
        if (this.cardTuxiangOption.being_treatment == '') wrongTxt = '正在进行的诊疗情况不能为空'
        else if (imgIndex) wrongTxt = '请上传图片并填写图片描述'
        else if (textIndex) wrongTxt = '请上传图片并填写图片描述'
        obj = {
          ...this.cardTuxiangOption,
          type_id: 4,
          patient_id: this.createItem.id
        }
      } else if (this.createType == '功能矫治器') {
        if (this.cardJiaozhiOption.design_card_id == '') wrongTxt = '请选择关联的设计单'
        obj = {
          ...this.cardJiaozhiOption,
          type_id: 6,
          patient_id: this.createItem.id
        }
      } else if (this.createType == '隐形矫治器加工') {
        if (this.cardYinxinOption.fuzhen_card_id == '') wrongTxt = '请选择关联的复诊卡'
        else if(this.cardJiaozhiOption.model_file_url == '') wrongTxt = '请上传文件'
        obj = {
          ...this.cardYinxinOption,
          type_id: 7,
          patient_id: this.createItem.id
        }
      }
      if (wrongTxt != '') {
        this.$refs.contRef.scrollTo({
          top: this.menuOffsetTop[0],
          behavior: 'smooth'
        })
        this.$message({
          type: 'error',
          message: wrongTxt
        })
        return false
      }
      this.$store.commit('workStart')
      CreateCaseCard(obj).then(res => {
        if (res.code == 200) {
          this.$message({
            type: 'success',
            message: '新建成功'
          })
          if(this.createType != '功能矫治器' && this.createType != '隐形矫治器加工'){
            this.$router.push({
              name:'病历管理',
              query:{
                id:this.createItem.id,
                card_id:res.data.id
              }
            })
          }else if(this.createType == '功能矫治器' ){
            this.$router.push({
              name:'订单详情',
              query:{
                id:res.data.order_id
              }
            })
          }else{
            GetLpyxjzWebUrl({patient_id: this.createItem.id}).then(res=>{
              window.open(res.data.web_url,'_blank')
            })
          }

        } else {
          this.$message({
            type: 'error',
            message: res.message[0]
          })
        }
        this.$store.commit('workOver')
      })
    }
  }
}
</script>
<style scoped src="../../assets/css/consumables.css"></style>
<style scoped src="../../assets/css/doctor-detail.css"></style>
<style scoped src="../../assets/css/case_management_add_case.css"></style>
<style>
.add-data-item-input {
  position: relative;
}

.add-data-item-input input, .add-data-item .el-cascader input {
  width: 176px;
  height: 34px;
  background: #F4F4F4;
  border-radius: 8px;
  padding: 0 10px;
  font-size: 14px;
  border: none;
  padding-left: 10px !important;
}

.add-data-item .el-cascader .el-input .el-icon-arrow-down {
  line-height: 36px;
}

.add-data-item-input .el-input__prefix {
  left: 150px;
  top: -2px;
}

.add-data-item-input .el-icon-arrow-right {
  color: #B1B1B1;
  font-size: 12px;
  font-weight: bold;
}

.add-data-item-input .icon-youjiantou {
  position: absolute;
  right: 10px;
  color: #B1B1B1;
  font-size: 10px;
  top: 8px;
  font-weight: bold;
}

.add-data-item-input input::placeholder {
  color: rgba(60, 60, 67, 0.3);
}

.add-data-item-input input:focus {
  background: rgba(254, 212, 0, 0.05);
  border: 1px solid #FED400;
}
/*上传图片样式*/
.upload-img-item .el-upload-dragger{
  width: fit-content;
  height: 100%;
  border: none;
  display: flex;
}
</style>

